import type { CartUI } from '@libs/common-node';

/**
 * Returns a new cart with the given line items removed from their fulfillment groups.
 * Groups left empty are dropped; `summary` is untouched so totals reconcile on the next refetch.
 */
export const removeLineItemsFromCart = (cart: CartUI, lineItemIds: string[]): CartUI => {
    if (lineItemIds.length === 0) {
        return cart;
    }

    const idsToRemove = new Set(lineItemIds);

    const fulfillmentGroups = (cart.fulfillmentGroups ?? [])
        .map(group => ({
            ...group,
            items: group.items.filter(item => !idsToRemove.has(item.id)),
        }))
        .filter(group => group.items.length > 0);

    return { ...cart, fulfillmentGroups };
};
